module.exports = __webpack_public_path__ + "band_1.463c74a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_1.png
// module id = 0VJS
// module chunks = 0